import { ViewportScroller } from '@angular/common';
import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';

import { CurrentLocationService } from '@services/current-location.service';
import { SaasSettingsService } from '@services/saas-settings.service';
import { TextService } from '@services/text.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, MatProgressSpinner]
})
export class AppComponent implements OnInit {
  public saasSettingsService = inject(SaasSettingsService);
  public viewportScroller = inject(ViewportScroller);
  private titleService = inject(Title);
  private currentLocationService = inject(CurrentLocationService);
  private textService = inject(TextService);
  private destroyRef = inject(DestroyRef);

  currentYear: number;

  pagePath: string;

  private APP_NAME = 'Hunch App';

  constructor() {
    this.viewportScroller.setOffset([0, 64]);
  }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    this.currentLocationService.getCurrentLocation();
    this.currentLocationService
      .getCurrentPage()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(pagePath => {
        this.pagePath = pagePath;
        const pageName = this.textService.createNameWithSpaces(pagePath);
        this.titleService.setTitle(pageName + ' - ' + this.APP_NAME);
      });
  }
}
